<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ modalTitle }} Franchise
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div *ngIf="!loadingForm">
    <form [formGroup]="franchiseForm" (ngSubmit)="saveFranchise(franchiseForm.value)">
        <div class="modal-body">

            <div class="row margin-top-8">
                <div class="col-md-4 label">*Name:</div>
                <div class="col-md-8">
                    <input type="text" pInputText formControlName="name" placeholder="Name" />
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Password Reset Template ID:</div>
                <div class="col-md-8">
                    <input type="text" pInputText formControlName="passwordResetTemplateID"
                        placeholder="Password Reset Template ID" />
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Custom Portal CSS:</div>
                <div class="col-md-8">
                    <textarea pInputTextarea formControlName="customPortalCSS"
                        placeholder="Custom Portal CSS"></textarea>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Custom Widget CSS:</div>
                <div class="col-md-8">
                    <textarea pInputTextarea formControlName="customWidgetCSS"
                        placeholder="Custom Widget CSS"></textarea>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">From Number:</div>
                <div class="col-md-8">
                    <input type="text" formControlName="fromNumber" pInputText placeholder="From Number" />
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Generate Data Feed Report:</div>
                <div class="col-md-8">
                    <div class="p-inputgroup">
                        <p-inputSwitch formControlName="generateDataFeedReport"></p-inputSwitch>
                        <small style="
              margin-left: 8px;
              margin-top: auto;
              margin-bottom: auto;
            ">
                        </small>
                    </div>
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <div class="row">
                <div class="col-md-8"></div>
                <div class="col-md-4">
                    <button [disabled]="busy" pButton class="full-width" label="{{modalSaveBtnText}}"
                        type="submit"></button>
                </div>
            </div>
        </div>
    </form>
</div>